import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';
import { useFormik } from 'formik';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';

import { graphErrorsToFormik } from '../../../utils/errors';
import appRoutes from '../../../routes/appRoutes';
import {
  initialValues,
  validationSchema,
} from '../../../forms/store/createStoreForm';
import FormHeader from '../../../components/FormHeader';
import StoreForm from '../../../components/StoreForm';
import { StoreProvider } from '../../../components';
import { createStore } from '../../../mutations';

import 'react-toastify/dist/ReactToastify.css';

const BrandNewView = (props) => {
  const { relay, lists, history } = props;
  const categories = lists.categories.edges.map((e) => e.node);
  const notify = () =>
    toast.success('Brand Successfully Created!', {
      position: 'top-right',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'colored',
    });

  const handleBrandCreate = async (values, actions) => {
    const params = {
      ...values,
      phoneNumber: values.phoneNumber.replace(/^\+?1/, ''),
    };
    actions.setSubmitting(true);
    await createStore(relay.environment, params, lists.id, {
      onCompleted: handleSubmitSuccess,
    });
    actions.setSubmitting(false);
  };

  const formik = useFormik({
    initialValues: initialValues(),
    onSubmit: handleBrandCreate,
    enableReinitialize: true,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema,
  });

  const { values, handleSubmit, setFieldValue, errors, setErrors } = formik;

  const handleSubmitSuccess = (response) => {
    let { errors, storeEdge } = response.createStore;
    if (errors) {
      setErrors(graphErrorsToFormik(errors));
    } else {
      const path = appRoutes.storeShowPath(storeEdge.node.id);
      history.push(path);
      notify();
    }
  };

  return (
    <div className="store-new">
      <form className="store-form" onSubmit={handleSubmit}>
        <FormHeader title="New Brand">
          <input
            id="saveStore"
            className="store-submit"
            type="submit"
            defaultValue="Save"
          />
        </FormHeader>

        <div className="form-fields">
          <StoreForm
            errors={errors}
            values={values}
            categories={categories}
            onChange={setFieldValue}
          />
        </div>
      </form>
    </div>
  );
};

const BrandNewContainer = withRouter(
  createFragmentContainer(BrandNewView, {
    lists: graphql`
      fragment BrandNew_lists on Lists {
        id
        categories(first: 1000) {
          edges {
            node {
              id
              name
            }
          }
        }
      }
    `,
  })
);

export default class BrandNew extends Component {
  render() {
    return (
      <StoreProvider
        modern
        container={BrandNewContainer}
        query={graphql`
          query BrandNewQuery {
            lists {
              ...BrandNew_lists
            }
          }
        `}
      />
    );
  }
}

BrandNewView.propTypes = {
  relay: PropTypes.shape().isRequired,
  lists: PropTypes.shape().isRequired,
  history: PropTypes.shape().isRequired,
};
